"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
var redux_1 = require("redux");
var ramda_1 = require("ramda");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var selectedChannelSlotInitialState = {};
var reducers = {
    categoryById: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_ALL_CHANNELS,
        onSuccess: function (draftState, action) {
            var _a, _b, _c;
            if (action.isNotModified) {
                return;
            }
            draftState.data = {};
            (_c = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.experience) === null || _b === void 0 ? void 0 : _b.channelGroups) === null || _c === void 0 ? void 0 : _c.forEach(function (channelGroup) {
                if (channelGroup) {
                    var id = channelGroup.id, title = channelGroup.title;
                    draftState.data[id] = {
                        id: id,
                        title: title,
                    };
                }
            });
        },
    }, {}),
    channelsByCategoryId: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_ALL_CHANNELS,
        onSuccess: function (draftState, action) {
            var _a, _b, _c;
            if (action.isNotModified) {
                return;
            }
            (_c = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.experience) === null || _b === void 0 ? void 0 : _b.channelGroups) === null || _c === void 0 ? void 0 : _c.forEach(function (channelGroup) {
                if (channelGroup) {
                    var id = channelGroup.id, channels = channelGroup.channels;
                    draftState.data[id] =
                        channels &&
                            // No empty channel should display
                            ramda_1.pluck('id', channels.filter(Boolean));
                }
            });
        },
    })), api_1.createApiInitialState({})),
    watchTvChannels: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_ALL_CHANNELS,
        onSuccess: function (draftState, action) {
            var _a, _b, _c, _d, _e;
            if (action.isNotModified) {
                return;
            }
            draftState.data = [];
            (_e = (_d = (_c = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.experience) === null || _b === void 0 ? void 0 : _b.sectionByPredefinedId) === null || _c === void 0 ? void 0 : _c.home) === null || _d === void 0 ? void 0 : _d.channels) === null || _e === void 0 ? void 0 : _e.forEach(function (channel) {
                if (channel) {
                    draftState.data.push(channel.id);
                }
            });
        },
    })), api_1.createApiInitialState([])),
    channelById: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_CHANNEL_BY_ID] = function (draftState, action) {
            var channels = action.payload.channels;
            var newState = draftState;
            if (action.payload.override) {
                // if override create a new state.
                newState = {};
            }
            channels === null || channels === void 0 ? void 0 : channels.forEach(function (channel) {
                newState[channel.id] = __assign(__assign(__assign({}, newState[channel.id]), channel), { slot: (channel === null || channel === void 0 ? void 0 : channel.slot) || (!ramda_1.isNil(channel.slots) && ramda_1.head(channel.slots)) });
            });
            return newState; // if override return new state. if not override return draftState (same as just 'return').
        },
        _a[constants_1.SET_SLOT_FOR_CHANNEL_WITH_ID] = function (draftState, action) {
            var channels = action.payload.channels;
            channels === null || channels === void 0 ? void 0 : channels.forEach(function (channel) {
                draftState[channel.id] = __assign(__assign({}, draftState[channel.id]), { slot: channel === null || channel === void 0 ? void 0 : channel.slot });
            });
        },
        _a), {}),
    selectedChannelId: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SET_SELECTED_CHANNEL_ID] = function (_, action) { return action.payload; },
        _b), ''),
    selectedCategoryId: api_1.createCustomModuleReducer((_c = {},
        _c[constants_1.SET_SELECTED_CATEGORY_ID] = function (_, action) { return action.payload; },
        _c), ''),
    selectedChannelSlot: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_SELECTED_CHANNEL_SLOT,
        onSuccess: function (draftState, action) {
            var _a, _b;
            draftState.data.slot = (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.linearChannel) === null || _b === void 0 ? void 0 : _b.slot;
        },
    })), (_d = {}, _d[constants_1.CLEAR_SELECTED_CHANNEL_SLOT] = function (draftState) {
        draftState.data = selectedChannelSlotInitialState;
    }, _d[constants_1.SET_SLOT_FOR_SELECTED_CHANNEL] = function (draftState, action) {
        var slot = action.payload.slot;
        draftState.data.slot = slot;
    }, _d)), api_1.createApiInitialState(selectedChannelSlotInitialState)),
    selectedSlot: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_LINEAR_SLOT_BY_ID,
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.linearChannelSlot;
        },
    })), api_1.createApiInitialState(null)),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map